import { render, staticRenderFns } from "./gk-progress.vue?vue&type=template&id=8795db70"
import script from "./gk-progress.vue?vue&type=script&lang=js"
export * from "./gk-progress.vue?vue&type=script&lang=js"
import style0 from "./gk-progress.vue?vue&type=style&index=0&id=8795db70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports